import React, { useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import MealDataModal from "./MealDataModal";

//Translation
import { useTranslation } from "react-i18next";

export default function Modal(props) {
  //translation
  const { t } = useTranslation();

  const { setMealReminder, mealReminder, clockOut, exceptionDate, exceptionTime, callingFromMissedClockOut, setDisableExceptionLoader, setDisableClockOut } = props;
  console.log("In Meal Reminder Modal",exceptionTime,exceptionDate);
  const [open, setOpen] = React.useState(true);
  let outTS;
 
  const handleClose = () => {
    setOpen(false);
    setDisableExceptionLoader(false);
    setMealReminder(false);
    clockOut();
  };

  const handleNewModal = () => {
    
    setMealData(true);
  };

  const [mealData, setMealData] = React.useState(false);
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        disableBackdropClick
      >
        <DialogTitle id="alert-dialog-title">
          {t("other.confirmMealTitle")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t("other.mealReminderContent")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" variant="outlined">
            {t("pgReview.btnNo")}
          </Button>
          <Button onClick={handleNewModal} color="primary" variant="contained">
            {t("pgReview.btnYes")}
          </Button>
        </DialogActions>
      </Dialog>
      {mealData && (
        <MealDataModal
          setMealData={setMealData}
          setMealReminder={setMealReminder}
          mealReminder={mealReminder}
          setDisableExceptionLoader = {setDisableExceptionLoader}
          exceptionDate={callingFromMissedClockOut?exceptionDate:null}
          exceptionTime={callingFromMissedClockOut?exceptionTime:null}
          callingFromMissedClockOut={callingFromMissedClockOut}
          setDisableClockOut = {setDisableClockOut}
        />
      )}
    </div>
  );
}
